import { render, staticRenderFns } from "./DetalleDeCita.vue?vue&type=template&id=bd50a1f6&scoped=true"
import script from "./DetalleDeCita.vue?vue&type=script&lang=js"
export * from "./DetalleDeCita.vue?vue&type=script&lang=js"
import style0 from "./DetalleDeCita.vue?vue&type=style&index=0&id=bd50a1f6&prod&scoped=true&lang=css"
import style1 from "./DetalleDeCita.vue?vue&type=style&index=1&id=bd50a1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50a1f6",
  null
  
)

export default component.exports